// extracted by mini-css-extract-plugin
export default {"note":"form-flag_note__ukSyQ"};